import { motion } from "framer-motion";
import { Play } from "lucide-react";

export const Video = () => (
  <section id="video" data-testid="video-section" className="grain relative bg-[#0a0a0a] px-6 py-28 lg:px-10 lg:py-40">
    <div className="mx-auto max-w-6xl">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-6 text-center text-[11px] font-semibold uppercase tracking-[0.4em] text-gold"
      >
        En vidéo
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, delay: 0.1 }}
        className="mb-16 text-center font-display text-4xl leading-tight tracking-tight text-white sm:text-5xl lg:text-6xl"
      >
        L'émotion <em className="italic text-gold">en mouvement.</em>
      </motion.h2>
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
        className="relative"
      >
        <div className="absolute -inset-3 rounded-[2rem] border border-gold/20" />
        <div className="relative overflow-hidden rounded-3xl border border-gold/30 shadow-2xl">
          <video
            src="/videos/entree-maries.mp4"
            autoPlay
            muted
            loop
            playsInline
            controls
            data-testid="wedding-entrance-video"
            className="aspect-video w-full object-cover"
          />
        </div>
        <div className="mt-6 flex items-center justify-center gap-3" data-testid="video-caption">
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gold text-[#0a0a0a]">
            <Play className="h-3.5 w-3.5 fill-current" />
          </span>
          <p className="text-xs uppercase tracking-[0.25em] text-white/50">
            Entrée des mariés en salle
          </p>
        </div>
      </motion.div>
    </div>
  </section>
);
